import { useMemo } from "react";
import { useUserPermissions } from "../../context/hooks";
import { hasRequiredPermission } from "../helpers";
import { PERMISSION } from "../permissions";
export var useIsSystemMaintainer = function () {
    var permissions = useUserPermissions();
    return useMemo(function () { return hasRequiredPermission([PERMISSION.SYSTEM_MAINTENANCE], permissions); }, [permissions]);
};
